import { render } from "./ParkingDashboard.vue?vue&type=template&id=ffbb8ada"
import script from "./ParkingDashboard.vue?vue&type=script&lang=js"
export * from "./ParkingDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__